import { RegistrationV2State, RegistrationV2Action } from './types.ts';
import * as actions from './actions.ts';

const INITIAL_STATE: RegistrationV2State = {
  email: null,
  validatedEmail: null,
  currentStep: 'email',
  preRegister: {
    isLoading: false,
    error: null,
    data: null,
  },
  codeValidation: {
    isLoading: false,
    error: null,
    data: null,
  },
  resendCode: {
    isLoading: false,
    error: null,
  },
  completeRegistration: {
    isLoading: false,
    error: null,
    data: null,
    skipOnboarding: false,
  },
  skills: [],
};

export const registrationV2Reducer = (
  state: RegistrationV2State = INITIAL_STATE,
  action: RegistrationV2Action
): RegistrationV2State => {
  switch (action.type) {
    case actions.REGISTRATION_V2_SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    
    case actions.REGISTRATION_V2_SET_VALIDATED_EMAIL:
      return {
        ...state,
        validatedEmail: action.payload,
      };
    
    case actions.REGISTRATION_V2_SET_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    
    case actions.REGISTRATION_V2_PRE_REGISTER_START:
      return {
        ...state,
        preRegister: {
          ...state.preRegister,
          isLoading: true,
          error: null,
        },
      };
    
    case actions.REGISTRATION_V2_PRE_REGISTER_SUCCESS:
      return {
        ...state,
        preRegister: {
          isLoading: false,
          error: null,
          data: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_PRE_REGISTER_FAIL:
      return {
        ...state,
        preRegister: {
          ...state.preRegister,
          isLoading: false,
          error: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_CODE_VALIDATION_START:
      return {
        ...state,
        codeValidation: {
          ...state.codeValidation,
          isLoading: true,
          error: null,
        },
      };
    
    case actions.REGISTRATION_V2_CODE_VALIDATION_SUCCESS:
      return {
        ...state,
        codeValidation: {
          isLoading: false,
          error: null,
          data: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_CODE_VALIDATION_FAIL:
      return {
        ...state,
        codeValidation: {
          ...state.codeValidation,
          isLoading: false,
          error: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_RESEND_CODE_START:
      return {
        ...state,
        resendCode: {
          isLoading: true,
          error: null,
        },
      };
    
    case actions.REGISTRATION_V2_RESEND_CODE_SUCCESS:
      return {
        ...state,
        resendCode: {
          isLoading: false,
          error: null,
        },
      };
    
    case actions.REGISTRATION_V2_RESEND_CODE_FAIL:
      return {
        ...state,
        resendCode: {
          isLoading: false,
          error: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_COMPLETE_REGISTRATION_START:
      return {
        ...state,
        completeRegistration: {
          ...state.completeRegistration,
          isLoading: true,
          error: null,
        },
      };
    
    case actions.REGISTRATION_V2_COMPLETE_REGISTRATION_SUCCESS:
      return {
        ...state,
        completeRegistration: {
          isLoading: false,
          error: null,
          data: action.payload.data,
          skipOnboarding: action.payload.skipOnboarding,
        },
      };
    
    case actions.REGISTRATION_V2_COMPLETE_REGISTRATION_FAIL:
      return {
        ...state,
        completeRegistration: {
          ...state.completeRegistration,
          isLoading: false,
          error: action.payload,
        },
      };
    
    case actions.REGISTRATION_V2_SET_SKILLS:
      return {
        ...state,
        skills: action.payload,
      };
    
    case actions.REGISTRATION_V2_CLEAR_FLOW:
      return INITIAL_STATE;
    
    default:
      return state;
  }
};

export default registrationV2Reducer;
